/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/views/web/product/context/ShopData.tsx
 * @Description: 商品详情页店铺信息
 */
import { createContext, useContext } from 'react';

const ShopDataContext = createContext(null);

const ShopDataContextProvider = ({ shop, children }) => {
  return <ShopDataContext.Provider value={{ shop }}>{children}</ShopDataContext.Provider>;
};

const useShopDataContext = () => {
  const context = useContext(ShopDataContext);
  if (context === undefined) {
    throw new Error('useShopDataContext must be used within a ShopDataContextProvider');
  }
  return context;
};
export { ShopDataContextProvider, useShopDataContext };
